import { useRouter } from 'next/router';
import { CiSearch } from 'react-icons/ci';
import Link from 'next/link';
import { FaRegClock } from 'react-icons/fa6';
import Image from 'next/image';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import classNames from '@/lib/misc/classNames';
export default function MobileTopNav({
  className
}: {
  className?: string;
}) {
  const router = useRouter();
  const {
    PFP
  } = useGetUserProfileInfo();
  const path = router.asPath;
  return <div className={classNames('w-full flex-grow lg:hidden fixed top-0 bg-genius-indigo z-50 h-[10vh]', className)} data-sentry-component="MobileTopNav" data-sentry-source-file="MobileTopNav.tsx">
      <div className='w-full flex items-center text-genius-cream justify-between relative py-2 px-3 gap-2'>
        <div>
          <Link href={`/settings?previousRoute=${path}`} data-sentry-element="Link" data-sentry-source-file="MobileTopNav.tsx">
            <Image src={PFP} alt='logo' height={100} width={100} className='w-[38px] h-[38px] rounded-full border-genius-blue border-[3px]' data-sentry-element="Image" data-sentry-source-file="MobileTopNav.tsx" />
          </Link>
        </div>

        <div className='flex items-center gap-1 rounded-md w-9/12 bg-genius-blue py-5 h-[40px] px-2 text-genius-cream/50 font-sans font-light text-[12px]' onClick={() => router.push('/home?mode=search')}>
          <CiSearch data-sentry-element="CiSearch" data-sentry-source-file="MobileTopNav.tsx" />
          {'Search for an asset'}
        </div>

        <div>
          <Link href='/history' aria-label='View history' data-sentry-element="Link" data-sentry-source-file="MobileTopNav.tsx">
            <FaRegClock className='w-[30px] h-[30px]' data-sentry-element="FaRegClock" data-sentry-source-file="MobileTopNav.tsx" />
          </Link>
        </div>
      </div>
    </div>;
}